import { useLayoutEffect } from 'react'
import { v4 } from 'uuid'
import { useControlStore } from '@editor/stores'

const useHideElements = (ids: string[] | string | null | undefined) => {
  const addHiddenElementIdGroup = useControlStore(state => state.addHiddenElementIdGroup)
  const removeHiddenElementIdGroup = useControlStore(state => state.removeHiddenElementIdGroup)

  useLayoutEffect(() => {
    if (!ids || ids.length === 0) return

    const actualIds = Array.isArray(ids) ? ids : [ids]

    const uuid = v4()

    addHiddenElementIdGroup(uuid, actualIds)

    return () => {
      removeHiddenElementIdGroup(uuid)
    }
  }, [addHiddenElementIdGroup, removeHiddenElementIdGroup, ids])
}

export default useHideElements
